<template>
  <codemirror
      v-model="code"
      :options="cmOption"
      placeholder="Code goes here..."
      :style="{ height: '400px' }"
      :autofocus="true"
      :indent-with-tab="true"
      :tab-size="2"
      :extensions="extensions"

      @ready="handleReady"
      @focus="log('focus', $event)"
      @blur="log('blur', $event)"

  />
  <!-- 创建节点-->
  <el-dialog title="创建节点" v-model="createNode" :close-on-click-modal="false" width="550px"
             style="--el-font-size-base: 12px">
    <div>
      <el-form v-model="nodes" label-width="100px" style="margin-right: 10px;">
        <el-row>
          <el-form-item label="节点id" required style="width: 100%">
            <el-input v-model="nodes.id" type="input" placeholder="请输入节点id (例如leader_review)"
                      clearable></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="节点名称" required style="width: 100%">
            <el-input v-model="nodes.name" type="input" placeholder="请输入名称 (例如领导审批)"
                      clearable></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="坐标X" required style="width: 50%">
            <el-input-number v-model="nodes.x" :min="30" :value-on-clear="30" :step="10" controls-position="right"
                             clearable></el-input-number>
          </el-form-item>
          <el-form-item label="坐标Y" required style="width: 50%">
            <el-input-number v-model="nodes.y" :min="30" :value-on-clear="30" :step="10" controls-position="right"
                             clearable></el-input-number>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="节点性质" style="width: 100%">
            <el-select v-model="nodes.node_type" placeholder="请选择节点性质" style="width: 100%">
              <el-option v-for="item in nodeType" :key="item.value" :label="item.lable" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row v-if="nodes.node_type !== 'end'">
          <el-form-item label="表单Id" required style="width: 100%">
            <el-input v-model="nodes.form_id" type="input" placeholder="请输入表单Id" clearable/>
          </el-form-item>
        </el-row>
        <el-row v-if="nodes.node_type !== 'end'">
          <el-form-item label="可使用角色" style="width: 100%">
            <el-select v-model="nodes.roles" placeholder="请选择可使用角色" multiple style="width: 100%">
              <el-option v-for="item in roleDataList" :key="item.id" :label="item.name" :value="item.id"/>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="节点触发器" style="width: 100%">
            <el-input v-model="nodes.in_triggers" placeholder="请输入节点触发器" multiple/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="节点颜色" style="width: 200px">
            <el-color-picker v-model="nodes.color" show-alpha :predefine="predefineColors"/>
          </el-form-item>
          <el-form-item label="节点字体颜色" style="width: 200px">
            <el-color-picker v-model="nodes.fontColor" show-alpha :predefine="predefineColors"/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="备注" style="width: 100%">
            <el-input v-model="nodes.remark" placeholder="请输入备注" multiple :autosize="{ minRows: 2, maxRows: 4 }"
                      type="textarea"/>
          </el-form-item>
        </el-row>
      </el-form>
      <el-button @click="createNewNode(graph,graph_parent)"
                 style="font-size: 13px;position: inherit;margin-left: 100px">确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { defineComponent } from 'vue'
import { Codemirror } from 'vue-codemirror'

import { javascript } from '@codemirror/lang-javascript'
import { oneDark } from '@codemirror/theme-one-dark'

export default defineComponent({
  components: {
    Codemirror
  },
  data() {
    return {
      // code:'hello world',
      code:'Hello, world!',
      log: console.log,
      cmOption: {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        foldGutter: true,
        styleSelectedText: true,
        mode: 'text/javascript',
        keyMap: "sublime",
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: "monokai",
        extraKeys: { "Ctrl": "autocomplete" },
        hintOptions:{
          completeSingle: false
        }
      },
      extensions: [javascript(), oneDark],

    }
  },
methods:{
  //   var source = graph.insertVertex(parent, null,'source',20,20,80,30);
  //   var target = graph.insertVertex(parent, null, 'Target', 200, 200, 80, 30);
  //   // 获取连线的连族点华标
  //   var sourcePoint = new mxPoint(120,88);
  //   var targetPoint = new mxPoint(188,120);
  //   console.log("sourcePoint-=",sourcePoint)
  //   console.log("targetPoint-=",targetPoint)
  //   var points = [];
  //   points.push(sourcePoint)
  //   points.push(targetPoint)
  //
  //   // 创建连线
  //   var edge = graph .insertEdge(parent, null,'', source, target);
  // // 战置连线的拐点
  //   console.log("points-=",points)
  //   edge.geometry.points = points;
  // edge.geometry.points = [sourcePoint, targetPoint];
  //创建节点
  // dialogNodes() {
  //   this.createNode = true;
  //   this.currentNodeId = '';
  //   this.nodes = {
  //     routes: []
  //   };
  //   this.nodes.x = 30;
  //   this.nodes.y = 30;
  // },

  // 生成节点
  // createNewNode() {
  //   console.log("createNewNode...")
  //   if (this.nodes.id === undefined) {
  //     return this.$message.error("节点Id不能为空");
  //   }
  //   for (let node of this.nodeDataList) {
  //     if (node.id === this.nodes.id) {
  //       return this.$message.error("节点Id不能重复");
  //     }
  //   }
  //   if (this.nodes.name === undefined) {
  //     return this.$message.error("节点名称不能为空");
  //   }
  //   if (this.nodes.x === undefined) {
  //     return this.$message.error("节点坐标X不能为空");
  //   }
  //   if (this.nodes.y === undefined) {
  //     return this.$message.error("节点坐标Y不能为空");
  //   }
  //   if (this.nodes.node_type === undefined) {
  //     this.nodes.node_type = 'general'
  //   }
  //   if (this.nodes.node_type !== 'end' && this.nodes.form_id === undefined) {
  //     return this.$message.error("节点表单Id不能为空");
  //   }
  //
  //   let node = {
  //     id: this.nodes.id,
  //     id_back: toRaw(this.nodes.id),
  //     name: this.nodes.name,
  //     x: this.nodes.x,
  //     y: this.nodes.y,
  //     form_id: this.nodes.form_id,
  //     roles: this.nodes.roles,
  //     in_triggers: this.nodes.in_triggers,
  //     node_type: this.nodes.node_type,
  //     routes: this.nodes.routes,
  //     color: this.nodes.color,
  //     fontColor: this.nodes.fontColor,
  //     remark: this.nodes.remark,
  //   };
  //   this.nodeDataList.push(node);
  //   console.log("this.nodeDataList-=", this.nodeDataList)
  //   this.clearImage();
  //   this.drawImage();
  //   this.createNode = false;
  //   this.nodes = {};
  //
  //   return this.$message.success("节点创建成功");
  // },
}
})
</script>
